import { useQuery } from '@tanstack/react-query';
import { getMemberById } from 'services/api/requests/commercial';

export const useGetMemberById = (id: number) => {
	return useQuery(['memberById', id], getMemberById, {
		onError: error => {
			console.log(error);
		},
		refetchOnWindowFocus: false,
	});
};
